<template>
	<div class="range">
		<date-box
			ref="from"
			:value="value.from"
			:type="type"
			:min="min[0]"
			:max="max[0]"
			:disabled="disabled"
			:prevLabel="prevLabel[0]"
			:nextLabel="nextLabel[0]"
			class="range__from"
			@input="onInput($event, value.to)"
			@enter="onEnter"
		/>
		<span class="range__divider">{{ divider }}</span>
		<date-box
			ref="to"
			:value="value.to"
			:type="type"
			:min="min[1]"
			:max="max[1]"
			:disabled="disabled"
			:prevLabel="prevLabel[1]"
			:nextLabel="nextLabel[1]"
			@input="onInput(value.from, $event)"
			@enter="onEnter"
		/>
	</div>
</template>
<script>
	import DateBox from '@/components/DateBox';

	export default {
		name: 'DateRange',
		components: {
			DateBox,
		},
		props: {
			value: {
				type: Object,
				default: () => ({ from: '', to: '' }),
			},
			type: {
				// datetime-local, date, month
				type: String,
				default: 'datetime-local',
			},
			min: {
				type: Array,
				default: () => ['1970-01-02', '1970-01-02'],
			},
			max: {
				type: Array,
				default: () => ['2038-01-18', '2038-01-18'],
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			prevLabel: {
				type: Array,
				default: () => ['', ''],
			},
			nextLabel: {
				type: Array,
				default: () => ['', ''],
			},
			divider: {
				type: String,
				default: '-',
			},
		},
		date() {
			return {
				from: '',
				to: '',
			};
		},
		methods: {
			onInput(from, to) {
				this.$emit('input', { from, to });
				this.from = from;
				this.to = to;
			},
			onEnter() {
				this.$emit('enter');
			},
			focus(target = 'from') {
				this.$refs[target].focus();
			},
		},
	};
</script>
<style lang="scss" scoped>
	DIV.range {
		display: flex;
		flex-wrap: wrap;

		.range__from {
			margin-right: 8px;
		}

		.range__divider {
			margin-right: 8px;
			line-height: 36px;
		}
	}
</style>
